<template>
  <div class="chat-window">
    <div class="chat-title">
      <span class="chat-message">窓口担当とのメッセージ</span>
    </div>
    <div class="chat-messages" id="chatArea" v-if="checkOrderStatus">
      <div
        v-for="(item, index) in messages"
        :key="index"
      >
        <div class="userName" v-if="item.from.name !== currentUser">
          {{
            item.from.role === "ADMIN"
              ? "窓口担当"
              : item.order.clientGroup.name
          }}&nbsp;&nbsp;
          {{ item.from.name }}
        </div>
        <ChatBaloon
          :key="item.id"
          :body="item.body"
          :files="item.files"
          :images="item.images"
          :currentUser="currentUser"
          :user="item.from.name"
          :is-canceled="item.isCanceled"
          :is-deleted="item.isDeleted"
          @click="onClickBalloon(item)"
        />
        <div :class="currentUser === item.from.name ? 'footer' : 'footerRight'">
          <template v-if="!item.isUnread && item.from.name !== currentUser">
            既読
          </template>
          {{ item.createdAt | humanize.date }}
        </div>
      </div>
    </div>
    <div class="chat-messages" id="chatArea" v-else>
      <span class="chat-message">
        メッセージ機能はご注文送信後に利用できます。
      </span>
    </div>

    <!-- メッセージ入力エリア -->
    <div class="MessageInputContainer">
      <!-- メッセージ入力 input -->
      <el-input
        class="MessageBodyInput"
        type="textarea"
        v-model="body"
        :autosize="{ minRows: 3, maxRows: 6 }"
        :disabled="!checkOrderStatus"
      ></el-input>

      <!-- メッセージ入力 ボタンエリア -->
      <div class="MessageInput-Buttons">
        <!-- 画像添付ボタン -->
        <el-upload
          class="AddAttachmentButton"
          ref="upload"
          action=""
          :auto-upload="false"
          :on-change="_onChangeAttachments"
          :file-list="fileList"
          accept=".jpg, .jpeg, .png, .doc, .xls, .ppt, .docx, .xlsx, .pptx, .pdf, .txt, .bmp"
          :on-remove="removeFile"
          :disabled="isUploadingImg || !checkOrderStatus"
        >
          <el-button
            size="small"
            type="default"
            :loading="isUploadingImg"
            :disabled="!checkOrderStatus"
          >
            {{ isUploadingImg ? 'アップロード中' : 'ファイルを選択' }}
          </el-button>
          <div class="el-upload__tip" slot="tip">
            15MB以内
          </div>
        </el-upload>

        <!-- 送信ボタン -->
        <div class="MessageSendButtonContainer">
          <el-button
            size="small"
            class="MessageSendButton"
            type="primary"
            :loading="isSending"
            :disabled="isUploadingImg || !checkOrderStatus"
            @click="onClickSendMessage"
          >
            送信
          </el-button>
        </div>
      </div>
    </div>

    <!-- メッセージを取り消す -->
    <el-dialog
      :visible.sync="isShowDialog"
      :show-close="false"
      :close-on-click-modal="!isCanceling"
      title="取り消しますか？"
      width="35%"
    >
      <div class="dialog-text">
        {{ selectedMessage.body }}<br />
        <small>
          {{ selectedMessage.createdAt | humanize.date }}
        </small>
      </div>

      <!-- アクション -->
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          plain
          :disabled="isCanceling"
          @click="isShowDialog = false"
        >
          キャンセル
        </el-button>
        <el-button
          type="danger"
          :loading="isCanceling"
          @click="onClickCancelMessage"
        >
          取り消す
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import MAX_FILE_SIZE from "../settings.js";

import ChatBaloon from "@/components/ChatBaloon.vue";

import FileUsecase from "@/usecases/file.usecase";
import UsecaseFactory from "@/usecases/usecase.factory";

import Auth from "@/services/auth.service";

const ALLOW_EXTS_IMG = ["jpg", "jpeg", "png", "bmp"];

export default {
  components: {
    ChatBaloon,
  },
  data () {
    return {
      isSending: false,
      isCanceling: false,
      messages: [],
      body: "",
      fileList: [],
      files: [],
      images: [],
      currentUser: "",
      isShowDialog: false,
      selectedMessage: {},
      isUploadingImg: false,
    };
  },
  props: {
    order: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {
    messageThreadOrderId: {
      immediate: true,
      handler () {
        this.updateMessages();
      },
    },
  },
  computed: {
    MAX_FILE_SIZE () {
      return MAX_FILE_SIZE.MAX_FILE_SIZE;
    },
    /**
     * メッセージスレッドは常に親注文単位。子注文詳細表示中は親 ID を使う。
     * 詳細の order がルートと一致するまで取得しない（誤った子 ID での取得を防ぐ）。
     */
    messageThreadOrderId () {
      const routeId = this.$route.params.id
        ? String(this.$route.params.id)
        : "";
      const o = this.order;
      if (!routeId || !o || !o.id || String(o.id) !== routeId) {
        return "";
      }
      if (o.parentOrder && o.parentOrder.id) {
        return String(o.parentOrder.id);
      }
      return String(o.id);
    },
    checkOrderStatus () {
      const orderStatus =
        this.order && this.order.status ? this.order.status.code : "";
      if (orderStatus === "DRAFT" || orderStatus === "ORDER_REQUEST") {
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    getExt (key) {
      var pos = key.lastIndexOf(".");
      if (pos === -1) return "";
      return key.slice(pos + 1);
    },
    checkExt (key) {
      // 拡張子を切り出す
      var ext = this.getExt(key);
      // 許可する画像拡張子かあるか確認
      if (ALLOW_EXTS_IMG.indexOf(ext) === -1) {
        return false;
      }
      return true;
    },

    /**
     * [_onChangeAttachments description]
     * @param   {[type]}  file      [file description]
     * @param   {[type]}  fileList  [fileList description]
     * @return  {[type]}            [return description]
     */
    async _onChangeAttachments (file, fileList) {
      const { raw, name } = file;

      // アップロード時のファイルサイズ制限
      // xxlarge: 15MB まで
      if (!usecase.file.validateFileSize(file, "xxlarge")) {
        // Pop file list
        fileList.pop();

        return;
      }

      // 保存する画像のカテゴリを分ける
      const category = "message";

      // ２バイト文字のファイル名をエスケープするかどうか（エンコード）
      const isEncode = true;

      try {
        this.isUploadingImg = true;

        const fileName = usecase.file.fetchFileName(name, category, isEncode);

        const result = await usecase.file.uploadFile(fileName, raw);

        this.fileList = fileList;

        const fileIsImg = this.checkExt(result.key);

        if (fileIsImg === true) {
          this.images.push(result.key);
        } else {
          this.files.push(result.key);
        }
      } catch (err) {
        console.log(err);

        // Pop file list
        fileList.pop();
      } finally {
        this.isUploadingImg = false;
      }
    },

    /**
     * [checkAndPushStoredFile description]
     * @param   {[type]}  file  [file description]
     * @return  {[type]}        [return description]
     */
    async checkAndPushStoredFile (file) {
      const { raw, name } = file;

      // アップロード済みのファイルを取得する形のためここではファイルサイズ制限の確認は行わなくて良い
      // if (!usecase.file.validateFileSize(file, "max")) {
      //   return;
      // }

      // 保存する画像のカテゴリ指定 + S3 へのオプション設定
      const category = "";
      const option = { contentType: raw.type };

      try {
        const fileName = usecase.file.fetchFileName(name, category);

        const result = await usecase.file.uploadFile(fileName, raw, option);

        const fileIsImg = this.checkExt(result.key);

        if (fileIsImg === true) {
          this.images.push(result.key);
        } else {
          this.files.push(result.key);
        }
      } catch (err) {
        console.log(err);
      }
    },

    /**
     * [removeFile description]
     * @param   {[type]}  file      [file description]
     * @param   {[type]}  fileList  [fileList description]
     * @return  {[type]}            [return description]
     */
    async removeFile (file, fileList) {
      this.images = [];
      this.files = [];

      for (var i = 0; i < fileList.length; i++) {
        await this.checkAndPushStoredFile(fileList[i]);
      }
    },

    initImageFiles () {
      this.$refs.upload.clearFiles();
      this.fileList = [];
    },

    async updateMessages () {
      const user = await authService.getCurrentUser();
      this.currentUser = user.attributes.name;
      const orderId = this.messageThreadOrderId;
      if (!orderId) {
        this.messages = [];
        return;
      }
      const messages = await usecase.message.getMessages({ orderId });

      this.messages = messages;

      this.markMessagesAsRead();
    },
    /**
     * メッセージを既読にする
     */
    markMessagesAsRead () {
      const { messages } = this;
      const unreadMessages = messages.filter(message => message.isUnread);

      Promise.all(unreadMessages.map((unreadMessage) => {
        const { id } = unreadMessage;
        usecase.message.markMessageAsRead({ id });
      }));
    },
    initMessageInput () {
      this.body = "";
      this.files = [];
      this.images = [];
      this.$refs.upload.clearFiles();
    },
    async onClickSendMessage () {
      // Validation
      if (this.body === "") {
        alert("本文を入力してください");

        return;
      }

      const { body, files, images } = this;
      const orderId = this.messageThreadOrderId;
      if (!orderId) {
        alert("注文情報の読み込みを待ってから再度お試しください");
        return;
      }

      try {
        this.isSending = true;

        const sentMessage = await usecase.message.sendMessage({
          orderId,
          body,
          files,
          images,
        });

        // Cleanup
        if (sentMessage) {
          await this.initMessageInput();
          await this.updateMessages();
        }
      } catch (err) {
        console.log(err);

        // Failed to send
        alert("送信に失敗しました。再度お試しください");
      } finally {
        this.isSending = false;
      }
    },

    /**
     * [onClickBalloon description]
     * @param   {[type]}  message  [message description]
     * @return  {[type]}           [return description]
     */
    onClickBalloon (message) {
      if (message.isCanceled) {
        return;
      }

      this.selectedMessage = message;
      this.isShowDialog = true;
    },

    /**
     * [onClickCancelMessage description]
     * @return  {[type]}  [return description]
     */
    async onClickCancelMessage () {
      const { id } = this.selectedMessage;
      const option = { id };

      this.isCanceling = true;

      const res = await usecase.message.cancelMessage(option);

      this.isCanceling = false;

      if (res.errors) {
        res.errors.forEach(error => {
          this.$notify.error({
            title: "エラー",
            message: error.message,
            duration: 5 * 1000,
          });
        });

        return;
      }

      const { messageCancel } = res.data;

      this.$notify.success({
        title: "メッセージを取り消しました",
        duration: 5 * 1000,
      });

      this.selectedMessage.isCanceled = messageCancel.isCanceled;
      this.selectedMessage.body = messageCancel.body;
      this.selectedMessage.images = messageCancel.images;
      this.selectedMessage.files = messageCancel.files;
      this.isShowDialog = false;
    },
  },

  /**
   * [beforeCreate description]
   */
  beforeCreate () {
    usecase.file = new FileUsecase();
    usecase.message = UsecaseFactory.create("message");
  },

  /**
   * [beforeDestroy description]
   */
  beforeDestroy () {
    Object.keys(usecase).map(key => {
      delete usecase[key];
    });
  },
};

const usecase = {};
const authService = new Auth();
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.chat-title {
  display: flex;
  border-bottom: solid 1px $--border-color-lighter;
  height: 62px;
}
.chat-message {
  margin: auto;
}
.chat-window {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.chat-messages {
  flex: 1;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
}
.MessageInputContainer {
  border-top: 1px solid $--border-color-lighter;
  padding: 10px;
}
.MessageInput-Buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin-top: 10px;
}
.MessageSendButtonContainer {
  text-align: right;
}
.userName {
  margin-left: 20px;
  font-size: 13px;
}
.footerRight {
  width: 55%;
  line-height: 1;
  float: left;
  margin-left: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: end;
  font-size: 13px;
}
.footer {
  width: 55%;
  line-height: 1;
  float: right;
  margin-right: 1.5rem;
  margin-bottom: 1.5rem;
  text-align: end;
  font-size: 13px;
}

.message-action {
  ::v-deep .el-drawer__header {
    margin-bottom: 20px;
  }

  .text-message {
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    overflow-x: hidden;
  }

  .text-date {
    font-size: 0.75rem;
  }

  .actions {
    padding: 0 20px;
  }
}

// メッセージの取り消しダイアログ
.chat-window {
  .dialog-text {
    margin: 1rem 0;
    font-size: 18px;
  }

  .dialog-footer {
    .el-button {
      border: none;
    }
  }
}
</style>
